import React, { useMemo } from 'react';
import ConsentManager from './ConsentManager';
// import ConsentManagerComponent from './ConsentManagerComponent';

/**
 * ConsentManagerDashboard Page - Wrapper for routing integration
 * Accessible by: CRO Administrator, Sponsor, Principal Investigator
 * 
 * Role-based behavior:
 * - CRO Administrator/Sponsor: See all submissions, can approve/reject
 * - Principal Investigator: See only their own submissions, view only
 */
const ConsentManagerDashboard = () => {
    // Get user from localStorage
    const user = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem('user') || '{}');
        } catch (error) {
            console.error('Error parsing user from localStorage:', error);
            return {};
        }
    }, []);

    // Map your role names to component role names
    const getUserRole = () => {
        const roleName = user.role?.roleName;

        switch (roleName) {
            case 'CRO Administrator':
                return 'CRO';
            case 'Sponsor':
                return 'SPONSOR';
            case 'Principal Investigator':
                return 'PI';
            default:
                return 'PI';
        }
    };

    // Get current PI name for filtering
    const getCurrentPIName = () => {
        // You can adjust this based on how you store PI name in your user object
        return user.name || user.username || 'Unknown PI';
    };

    const userRole = getUserRole();
    const currentPIName = getCurrentPIName();

    console.log('ConsentManagerDashboard:', {
        originalRole: user.role?.roleName,
        mappedRole: userRole,
        piName: currentPIName,
    });

    return (
        <ConsentManager
            userRole={userRole}
            currentPIName={currentPIName}
            userId={user.id}
        />
    );
};

export default ConsentManagerDashboard;